import { drugsMandatoryTreatmentAddressNameFields } from 'constants/enums/people';
import { ValidateJSModel } from 'forms/shared/types';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { hasYesOrNo } from 'models/validate';
import { SubstanceDrugsVoluntaryTreatmentModel } from './types';
import { substanceDrugsVoluntaryTreatmentItemValidator } from './validators/item';

const substanceDrugsVoluntaryTreatmentValidator: ValidateJSModel<SubstanceDrugsVoluntaryTreatmentModel> = {
  TreatmentVoluntary: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes, attributeName, options) => {
    if (attributes?.TreatmentVoluntary && attributes?.TreatmentVoluntary.value === 'Yes') {
      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, drugsMandatoryTreatmentAddressNameFields);

      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }

      return {
        ...additionalValidation,
        presence: true,
        accordion: { validator: substanceDrugsVoluntaryTreatmentItemValidator },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};
export default substanceDrugsVoluntaryTreatmentValidator;
